import React, { useState } from "react";
import localeText from "../../../../../../../locale";
import FormSectionHeader from "../components/FormSectionHeader";
import VariationAttributeEditor from "../components/VariationAttributeEditor";
import VariationCombinationsTable from "../components/VariationCombinationsTable";
import SelectImageModal from "../components/SelectImageModal";
import { cloudinaryPreview, createLocalId } from "../utils";

function VariationsSection({ form }) {
  const [editingIndex, setEditingIndex] = useState(null);
  const [imageIndex, setImageIndex] = useState(null);

  if (!form.hasVariations || form.productType !== 1) return null;

  const attributes = form.variationAttributes || [];
  const showEmptyState = attributes.length === 0;

  const startFirstOption = () => {
    form.setVariationAttributes([{ localId: createLocalId(), name: "", values: [] }]);
    setEditingIndex(0);
  };

  const svgIcon = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.625 0V2.625H0V4.375H2.625V7H4.375V4.375H7V2.625H4.375V0H2.625ZM1.75 16.6308V8.75H3.5V15.75H10.5V11.375C10.5 10.8937 10.8937 10.5 11.375 10.5L15.75 10.4991V3.5H8.75V1.75H16.6308C17.1108 1.75 17.5 2.14879 17.5 2.62716V12.25L12.25 17.4965L2.62693 17.5C2.14261 17.5 1.75 17.1107 1.75 16.6308ZM15.0246 12.2491L12.25 12.25V15.0229L15.0246 12.2491Z"
        fill="var(--theme-secondary)"
      />
    </svg>
  );

  return (
    <section className="product-form-card flex flex-column gap-4">
      <FormSectionHeader
        icon={svgIcon}
        title={localeText("productVariations")}
        subtitle={localeText("productVariationsSubtitle")}
      />

      {showEmptyState ? (
        <div className="product-form-empty">
          <button type="button" className="product-form-empty-cta" onClick={startFirstOption}>
            <i className="pi pi-plus-circle" />
            <span>{localeText("addVariationOptions")}</span>
          </button>
        </div>
      ) : (
        <>
          <VariationAttributeEditor
            attributes={attributes}
            onChange={form.setVariationAttributes}
            editingIndex={editingIndex}
            setEditingIndex={setEditingIndex}
          />
          <VariationCombinationsTable
            combinations={form.variationCombinations}
            onChange={form.setVariationCombinations}
            onSelectImage={setImageIndex}
            currencyCode={form.currencyCode}
            stockDisabled={form.isStockLocked}
          />
        </>
      )}

      {/* <SelectImageModal
        visible={imageIndex != null}
        onHide={() => setImageIndex(null)}
        images={form.images}
        onConfirm={(selected) => {
          if (imageIndex == null) return;
          const next = [...form.variationCombinations];
          if (selected?.file) {
            next[imageIndex] = {
              ...next[imageIndex],
              imageFile: selected.file,
              previewUrl: URL.createObjectURL(selected.file),
              imageId: null,
            };
          } else if (selected?.id) {
            next[imageIndex] = {
              ...next[imageIndex],
              imageId: selected.id,
              previewUrl: selected.previewUrl || cloudinaryPreview(selected.id),
              imageFile: null,
            };
          }
          form.setVariationCombinations(next);
          setImageIndex(null);
        }}
      /> */}
    </section>
  );
}

export default VariationsSection;
